import React from 'react';

import Button from 'components/Button';
import './style.scss';

interface StepsBackButtonProps {
  onClick: () => void;
}

const StepsBackButton = ({ onClick }: StepsBackButtonProps) => {
  return (
    <div className="Back_button">
      <Button
        title={{
          id: 'components.LoversQuiz.Steps.back',
        }}
        onClick={onClick}
      />
    </div>
  );
};

export default StepsBackButton;
